import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchMetrics(containerRef) {
  return NGXAjax.get(`/api/metric/list.json`, {
    containerRef,
  }).then(resolve, reject);
}

export { fetchMetrics };
